<template>
    <el-dialog title="提交操作结果" :visible.sync="visible" width="700px" :close-on-click-modal="false" :close-on-press-escape="false">
        <div id="commitResult">
            <span style="color: #7F7F7F">点击对应题目提交按钮，获取校验结果和得分：</span>
            <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    prop="sort"
                    label="小题序号"
                     v-if="question&&question.crosshead&&question.crosshead.length>0">
                    <template slot-scope="scope">
                        {{scope.row.sort == null ? "": scope.row.sort + 1}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="resultMessage"
                    label="校验结果"
                    >
                </el-table-column>
                <el-table-column
                    prop="score"
                    label="本次得分/总分"
                    >
                    <template slot-scope="scope">
                        {{scope.row.score == null ? '?' : scope.row.score}}/{{scope.row.orginalScore}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="submit(scope.row.sort)">提交校验</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit(null)">一键提交</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {executeCommand} from "@/api/training";
import {getCurrentAnswer} from "@/api/exam";

export default {
    name: "commitOperationDialog",
    props: ['instancesId', 'questionList'],
    data() {
        return {
            visible: false,
            tableData: [],
        }
    },
    computed: {
        question() {
            return this.questionList.find(item => item.id == parseInt(this.$route.query.examPaperQuestionId))
        }
    },
    methods: {
        submit(sort) {
            this.$emit('postOperate', this.instancesId, parseInt(this.$route.query.examPaperQuestionId))
            executeCommand(this.instancesId, {
                questionId: parseInt(this.$route.query.examPaperQuestionId),
                questionCrossheadIndex: sort
            }).then(res => {
                this.$message.success('提交成功')
                this.loadTableData(res.data)
            }).catch(err => {
                this.$message.error("提交失败，服务端错误。请联系管理员或稍后重试");
            })
        },
        open() {
            this.visible = true
            if (this.$route.query.exam) {
                getCurrentAnswer().then(res => {
                    let currentQuestionAnswer = res.data.questionAnswerList.find(item => item.questionId == this.$route.query.examPaperQuestionId)
                    if (currentQuestionAnswer) {
                        this.loadTableData(JSON.parse(currentQuestionAnswer.validResult))
                    } else {
                        this.loadTableData()
                    }
                })
            }
        },
        loadTableData(reviewData) {
            this.tableData = []
            if (!reviewData) {
                if (this.question && this.question.crosshead && this.question.crosshead.length > 0) {
                    this.question.crosshead.forEach((res, index) => {
                        this.tableData.push({
                            sort: index,
                            resultMessage: null,
                            score: null,
                            orginalScore: res.score
                        })
                    })
                } else {
                    this.tableData.push({
                        sort: null,
                        resultMessage: null,
                        score: null,
                        orginalScore: this.question.score
                    })
                }
            } else {
                if (this.question && this.question.crosshead && this.question.crosshead.length > 0) {
                    this.question.crosshead.forEach((res, index) => {
                        let already = reviewData.find(item => item.question_crosshead_index == index)
                        if (already) {
                            this.tableData.push({
                                sort: index,
                                resultMessage: already.script_execute_result_message,
                                score: already.script_execute_result_score,
                                orginalScore: res.score
                            })
                        } else {
                            this.tableData.push({
                                sort: index,
                                resultMessage: null,
                                score: null,
                                orginalScore: res.score
                            })
                        }
                    })
                } else {
                    if (reviewData.length >0 ) {
                        this.tableData.push({
                            sort: null,
                            resultMessage: reviewData[0].script_execute_result_message,
                            score: reviewData[0].script_execute_result_score,
                            orginalScore: this.question.score
                        })
                    } else {
                        this.tableData.push({
                            sort: null,
                            resultMessage: null,
                            score: null,
                            orginalScore: this.question.score
                        })
                    }

                }

            }
        }
    }
}
</script>
